
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.64 7.86A2.49 2.49 0 0110 5.45V1.51a.5.5 0 111 0v2.94a.5.5 0 001 0V1.51a.5.5 0 111 0v2.94a.5.5 0 001 0V1.51a.5.5 0 011 0v4a2.5 2.5 0 01-1.64 2.35l.45 3.66a1.32 1.32 0 11-2.62.32.86.86 0 010-.32zm-6.89 3.43V9A4 4 0 011.5 5a7.37 7.37 0 011.29-4h5A8.29 8.29 0 019 5.06 3.72 3.72 0 015.75 9v2.25c.34 0 .72 0 1.11.09a1 1 0 01.89 1v.14c0 .18-.17.28-.51.31H3.3c-.37 0-.55-.13-.55-.31v-.14a1 1 0 01.89-1q.6-.08 1.11-.09z"}})])
          )
        }
      }
    